import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Pagination } from "@customTypes/index";
import { Radiology } from "@customTypes/radiology";

import { radiologyQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Radiology[] = [];

    for (const i in res.data.data) {
      const {
        _id,
        rad_type,
        reason,
        ordered_by,
        aid,
        status,
        date,
        fast_consultation,
        patient_id,
        consultation_id,
        consultation_info,
        files,
        updated_at,
      } = res.data.data[i];

      if (fast_consultation && consultation_info) {
        newData.push({
          id: _id,
          consultationId: consultation_id,
          consultationInfo: {
            consultationType: consultation_info?.consultation_type,
            physician: {
              id: consultation_info?.physician?._id,
              fullName: consultation_info?.physician?.full_name,
            },
            cId: consultation_info?.c_id,
          },
          patientId: patient_id,
          date: new Date(date),
          isFastConsultation: fast_consultation,
          files,
          reason,
          radType: "N/A",
          orderedBy: {
            fullName: ordered_by?.full_name,
            id: ordered_by?._id,
          },
          supportStaff: {
            id: aid?._id,
            fullName: aid?.full_name,
          },
          status,
          updatedAt: new Date(updated_at),
        });
      } else {
        newData.push({
          id: _id,
          consultationId: consultation_id,
          consultationInfo: {
            consultationType: consultation_info?.consultation_type,
            physician: {
              id: consultation_info?.physician?._id,
              fullName: consultation_info?.physician?.full_name,
            },
            cId: consultation_info?.c_id,
          },
          patientId: patient_id,
          date: new Date(date),
          isFastConsultation: fast_consultation,
          files,
          reason,
          radType: rad_type,
          orderedBy: {
            fullName: ordered_by?.full_name,
            id: ordered_by?._id,
          },
          supportStaff: {
            id: aid?._id,
            fullName: aid?.full_name,
          },
          status,
          updatedAt: new Date(updated_at),
        });
      }
    }

    // console.log(newData);
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  patientId: string;
  withFilesOnly?: boolean;
  fastConsultationOnly?: boolean;
  pagination?: Partial<Pagination>;
  search?: string;
  isEnabled?: boolean;
  status?: string;
  consultationId?: string;
}

export const useGetRadiologyForPatient = ({
  patientId,
  fastConsultationOnly,
  pagination,
  status,
  consultationId,
  withFilesOnly = false,
  isEnabled = true,
  search = "",
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: radiologyQKeys.patientWithFilters(patientId, {
      withFilesOnly,
      fastConsultationOnly,
      pagination,
      ...(search && { search }),
      ...(consultationId && { consultationId }),
      status,
    }),
    queryFn: () => {
      return api.get(`radiology/patient/${patientId}`, {
        params: {
          only_with_files: withFilesOnly,
          ...(typeof fastConsultationOnly !== "undefined" && {
            fast_consultation: fastConsultationOnly,
          }),
          ...(consultationId && { consultation_id: consultationId }),
          ...(search && { search }),
          ...(status && { status }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
        },
      });
    },
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Radiology for Patient]", res);
      handleErrors(res, "query");
    },
  });
};
